import { useMemo } from "react"

/**
 * Custom hook to compute and memoize trip status flags
 */
export const useTripStatus = (trip, booking) => {
    const status = useMemo(
        () => ({
            isPublished: trip?.status === "published",
            isCompleted: booking?.status === "completed",
            isBooked: booking?.status === "booked",
            isCanceled: booking?.status === "canceled",
            isRequested: booking?.status === "requested"
        }),
        [trip?.status, booking?.status]
    )

    return status
}
